import React from 'react'
import HeroImage from './images/hero.svg'
import styles from './Hero.module.scss'
import { Hero } from 'components/tools/common/Hero'
import { RouteEnum } from 'enums/RouteEnum'

const DomainTrendsHero: React.FC = () => {
  const breadcrumbsPath = [
    { text: 'Tools', href: '/' },
    { text: 'Free Tools', href: '/' },
    { text: 'Domain Trends', href: RouteEnum.DOMAIN_TRENDS },
  ]
  return (
    <Hero
      withImage
      breadcrumbsPath={breadcrumbsPath}
      title={'Domain Trends'}
      description={`We help you keep up with the latest domain trends in any industry. All you have to do is add the keyword you want to track and get everything you need in a click. Our regular and prompt database update guarantees you will never miss a new trend in your industry.`}
    >
      <HeroImage className={styles.image} />
    </Hero>
  )
}

export default DomainTrendsHero
